import { AuthService } from '@/app/shared/services/auth.service';
import { CommonService } from '@/app/shared/services/common.service';
import { SharedModule } from '@/app/shared/shared.module';
import { LoginModalComponent } from '@/app/shared/widgets/login-modal/login-modal.component';
import { Component, Inject, PLATFORM_ID, TransferState, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-welcome-back',
  standalone: true,
  imports: [SharedModule],
  templateUrl: './welcome-back.component.html',
  styleUrl: './welcome-back.component.scss'
})
export class WelcomeBackComponent {

  @ViewChild("loginModal", { static: false }) loginModal: LoginModalComponent;

  isAuthenticated: boolean = false;
  showLoginPopup: boolean = false;
  isExpanded: boolean = false;

  public services = [
    {
      status: true,
      description: "Minh bạch • Đồng hành • Chịu mọi rủi ro cùng đối tác",
      title: "Niềm Tin",
      image_url: 'assets/svg/home/trust.svg',
    },
    {
      status: true,
      description: "Đặt hàng nhanh • Xử lý tức thì • Giao đúng hẹn",
      title: "Tốc Độ",
      image_url: 'assets/svg/home/fast.svg',
    },
    {
      status: true,
      description: "Hàng chính hãng • Chuẩn quy trình • Kiểm soát nghiêm ngặt",
      title: "An Toàn",
      image_url: 'assets/svg/home/safe.svg',
    },
    {
      status: true,
      description: "Chi phí tối ưu • Chia sẻ lợi nhuận • Phát triển bền vững",
      title: "Hiệu Quả",
      image_url: 'assets/svg/home/effect.svg',
    },
    {
      status: true,
      description: "Lắng nghe • Chia sẻ • Phụng sự cộng đồng",
      title: "Nhân Văn",
      image_url: 'assets/svg/home/humanities.svg',
    }
  ];

  constructor(
    private commonService: CommonService,
    private router: Router,
    private authService: AuthService,
    private toastService: ToastrService,
  ) { }

  ngOnInit() {
    this.isAuthenticated = this.authService.isAuthenticated();

    if (this.isAuthenticated) {
      this.authService.checkinCampaign({campaignName: 'DvWelcomeLetterCampaign'}).subscribe({});
    }

    this.commonService.authEvent.subscribe({
      next: (data: any) => {
        if (data) {
          this.toastService.success('', 'Đăng nhập thành công!', { timeOut: 3000, positionClass: 'toast-top-right' });
          this.loginModal.closeModal();
        }
        this.isAuthenticated = this.authService.isAuthenticated();
      },
    });
  }

  openLoginModal() {
    this.loginModal.openModal();
  }

  gotoQuickOrder() {
    this.router.navigateByUrl('/quick-order');
  }

  goto(path: string) {
    this.router.navigateByUrl(path);
  }

  toggleAnswer(id: string, imgId: string) {
    $('#' + id).toggleClass('active');
    $('#' + imgId).toggleClass('active');
  }

  receiveReward() {
    this.router.navigateByUrl('/account/wallet', { state: { fromWelcomeBack: true } });
  }
}
